import TextField from "@mui/material/TextField";
import { useState } from "react";
import { formatCurrency } from "../utils";

const decimals = /^\d*\.?\d*$/;

const CurrencyField = (props) => {
  const propsValue = props.value || "0.00";
  const [value, setValue] = useState(formatCurrency(propsValue));

  const onBlur = (event) => {
    const oldValue = formatCurrency(propsValue);
    const newValue = formatCurrency(event.target.value);

    setValue(newValue);

    if (newValue !== oldValue) {
      props.onChange(newValue.replaceAll(",", ""));
    }
  };

  const onChange = (event) => {
    const { value } = event.target;
    if (decimals.test(value)) {
      setValue(value);
    }
  };

  const onFocus = (event) => {
    setValue(event.target.value.replaceAll(",", ""));
  };

  return (
    <TextField
      {...props}
      onBlur={onBlur}
      onChange={onChange}
      onFocus={onFocus}
      value={value}
    />
  );
};

export default CurrencyField;
